// Copyright 2023, Alexander Nekrasov, All rights reserved.

import { getAccount } from "../code/global";

export default {
  install(app /*, options*/) {
    if (app.config?.globalProperties) {
      //console.log("Vue3");
      app.config.globalProperties.$account = getAccount();
    } else if (app.prototype) {
      //console.log("Vue2");
      app.prototype.$account = getAccount();
    }
  },
};
